// Functionality for grantees index page.
// Controls the filter functionality for the grantees list.

(function () {
  // Filter controls
  const regionsSelect = document.querySelector(
    '[data-filter-control="grantees-region"]'
  );
  const yearsSelect = document.querySelector(
    '[data-filter-control="grantees-year"]'
  );
  const talentsSelect = document.querySelector(
    '[data-filter-control="grantees-talent"]'
  );
  const resetButton = document.querySelector("[data-filter-reset]");

  // Grantees list
  const granteesWrapper = document.querySelector(
    '[data-js="grantees_wrapper"]'
  );
  const grantees = [
    ...document.querySelectorAll('[data-filter="grantee_item"]'),
  ];
  const years = [...document.querySelectorAll("[data-year-group]")];

  doGranteesFilter();

  function filterGrantees() {
    if ("startViewTransition" in document) {
      document.startViewTransition(() => {
        doGranteesFilter();
      });
    } else {
      doGranteesFilter();
    }
  }

  function doGranteesFilter() {
    const selectedRegion = regionsSelect.value;
    const selectedTalent = talentsSelect.value;

    const granteeLabels = document.getElementsByClassName("grantee-label");

    for (let i = 0; i < granteeLabels.length; i++) {
      if (granteeLabels[i].dataset.site === selectedRegion) {
        granteeLabels[i].classList.remove("excluded");
      } else {
        granteeLabels[i].classList.add("excluded");
      }
    }

    years.forEach((year) => {
      year.dataset.isEmpty = "true";
    });

    grantees.forEach((grantee) => {
      const region = grantee.dataset.region;
      const talent = grantee.dataset.talent;
      if (
        (selectedRegion === "" || region === selectedRegion) &&
        (selectedTalent === "" || talent === selectedTalent)
      ) {
        grantee.classList.remove("excluded");
        years.forEach((year) => {
          if (year.dataset.yearGroup === grantee.dataset.year) {
            year.dataset.isEmpty = "false";
          }
        });
      } else {
        grantee.classList.add("excluded");
      }
    });

    // remove the hidden class from the wrapper (this stops ugly flashes of unfiltered content)
    granteesWrapper.classList.remove("opacity-0");
  }

  function filterYears() {
    const selectedYear = yearsSelect.value;

    if ("startViewTransition" in document) {
      document.startViewTransition(() => {
        doYearsFilter();
      });
    } else {
      doYearsFilter();
    }

    function doYearsFilter() {
      years.forEach((year) => {
        const yearGroup = year.dataset.yearGroup;
        if (selectedYear === "" || yearGroup === selectedYear) {
          year.classList.remove("excluded");
        } else {
          year.classList.add("excluded");
        }
      });
    }
  }

  function resetFilters() {
    regionsSelect.value = "";
    talentsSelect.value = "";
    yearsSelect.value = "";
    filterYears();
    doGranteesFilter();
  }

  regionsSelect.addEventListener("change", filterGrantees);
  talentsSelect.addEventListener("change", filterGrantees);
  yearsSelect.addEventListener("change", filterYears);
  resetButton.addEventListener("click", resetFilters);
})();
